 
import { Component, OnInit } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { PopUpComponent } from './pages/pop-up/pop-up.component';
import { MatDialog } from '@angular/material/dialog';

@Component({

  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})

export class AppComponent implements OnInit {

  url: string;

  title = 'FrontInmuebles';

  visible: boolean = false;

  visible2: boolean = false;

  abrirMenu: boolean = false;

  mostrarSearch: boolean = false;

  constructor(private route: Router, private dialog: MatDialog) {

    console.log("inicio router");

    this.mostrarSearch = this.route.url.includes('inmuebles');

    this.route.events.subscribe(event => {

      if (event instanceof RoutesRecognized) {

        if (event['url']) {

          this.url = event['url'];

          console.log("this.url " + this.url);

          if (this.url === '/' || this.url === '/home') {

            localStorage.removeItem('tipoInmueble');

            localStorage.removeItem('estado');

            localStorage.removeItem('ciudadesSeleccionadas');

            localStorage.removeItem('rango');

          }

          if (this.url.includes("inmuebles") || this.url.includes("detalle")) {

            this.mostrarSearch = true;

          } else {

            this.mostrarSearch = false;

          }

          if (this.url.includes("home") || this.url === ("/") ) {

            this.visible = true;

          } else {

            this.visible = false;

          }

          if (this.url.includes("home") || this.url === ("/") || this.url.includes("inmuebles")) {

            this.visible2 = true;

          } else {

            this.visible2 = false;

          }

        }

      }

    })

  }

  ngOnInit(): void {

    this.openPopup();

  }

  displayChange(event) {

    console.log("ingreso a displayChange " + event);

    this.abrirMenu = event;

    console.log(this.abrirMenu);

  }

  openPopup(): void {
    const dialogRef = this.dialog.open(PopUpComponent, {
      panelClass: 'popup-home',
      autoFocus: false,
      disableClose: true
    });

    document.body.classList.add('disable-scroll');

    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('disable-scroll');
    });
  }

}
 